import { render, staticRenderFns } from "./producer-query.vue?vue&type=template&id=36170104&scoped=true"
import script from "./producer-query.vue?vue&type=script&lang=js"
export * from "./producer-query.vue?vue&type=script&lang=js"
import style0 from "./producer-query.vue?vue&type=style&index=0&id=36170104&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36170104",
  null
  
)

export default component.exports